import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-search-results',
  templateUrl: './no-search-results.component.html',
  styleUrls: ['./no-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoSearchResultComponent {
  @Input() searchTerm: string;
}
